exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".adYouTube__youtubeIcon___2JaDY {\n  position: absolute;\n  margin-right: 0; }\n  .adYouTube__youtubeIcon___2JaDY.adYouTube__regularIcon___3k2CP {\n    max-width: 32px;\n    bottom: 5px;\n    right: 0px; }\n  .adYouTube__youtubeIcon___2JaDY.adYouTube__searchPageIcon___2IWmF {\n    max-width: 36px;\n    bottom: 14px;\n    right: 13px;\n    padding-inline: 5px;\n    height: 30px;\n    background-color: rgba(0, 0, 0, 0.5); }\n  @media (max-width: 576px) {\n    .adYouTube__youtubeIcon___2JaDY.adYouTube__regularIcon___3k2CP {\n      bottom: -2px; }\n    .adYouTube__youtubeIcon___2JaDY.adYouTube__searchPageIcon___2IWmF {\n      bottom: 8px;\n      max-width: 30px;\n      right: 12px;\n      height: 27px;\n      padding: 2px 5px; } }\n", ""]);

// exports
exports.locals = {
	"youtubeIcon": "adYouTube__youtubeIcon___2JaDY",
	"regularIcon": "adYouTube__regularIcon___3k2CP",
	"searchPageIcon": "adYouTube__searchPageIcon___2IWmF"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/AdCard/AdYouTube/adYouTube.scss
// module id = 3908
// module chunks = 6